<script setup lang="ts">
import {useCachedProduct} from "~/components/server/useCachedProduct";
import { getCategoryBreadcrumbs } from "@shopware/helpers";
const { navigationElements } = useNavigation();
const { search } = useProductSearch();
const { buildDynamicBreadcrumbs, pushBreadcrumb } = useBreadcrumbs();
const { apiClient } = useShopwareContext();
const errors = ref<string[]>([]);

const props = defineProps<{
  navigationId: string;
  class?: any,
}>();

const { data, error } = await useAsyncData(
    `cmsProduct${props.navigationId}`,
    async () => {
      const responses = await Promise.allSettled([
        search(props.navigationId, {
          withCmsAssociations: true,
          associations: {
            seoUrls: {},
            media: { associations: { media: {} } },
            cover: { associations: { media: {} } },
          },
        }),
        apiClient.invoke("readBreadcrumb get /breadcrumb/{id}", {
          pathParams: {
            id: props.navigationId,
          },
        }),
      ]);

      for (const response of responses) {
        if (response.status === "rejected") {
          console.error("[FrontendDetailPage.vue]", response.reason.message);
          errors.value.push(response.reason.message);
        }
      }

      return {
        productResponse:
            responses[0].status === "fulfilled" ? responses[0].value : null,
        breadcrumbs:
            responses[1].status === "fulfilled" ? responses[1].value : null,
      };
    },
);
const productResponse = data.value?.productResponse;


if (!productResponse) {
  console.error("[FrontendDetailPage.vue]", 'Product could not be found or loaded.');
  throw createError({
    statusCode: 404,
    statusMessage: `Product could not be found or loaded.`,
  });
}

const breadcrumbs = getCategoryBreadcrumbs(
  productResponse.product.seoCategory,
  {
    startIndex: 1,
  },
);
useBreadcrumbs(breadcrumbs);

useProductJsonLD(productResponse.product, { breadcrumbs });

const { product } = useProduct(
  productResponse.product,
  productResponse.configurator,
);

useCmsHead(product, { mainShopTitle: useRuntimeConfig().public.general.shopTitle });

if(product.value.translated.metaTitle) {
  useHead({
    title: product.value.translated.metaTitle + ' | ' + useRuntimeConfig().public.general.shopTitle,
  });
}
</script>
<template>
  <section class="section section-product-details">
    <LayoutBreadcrumbs />
    <ProductStatic v-if="product" :product="product" />
    <CmsPage v-if="product.cmsPage" :content="product.cmsPage" />
  </section>
</template>
